import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { PackageTableService } from '../../shared/tables/packages-table.service';
import { PackagesData } from './packages.data';
import { packageTableRequest } from '../../../store/package-table/package-table.actions';
import { AsyncPipe } from '@angular/common';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef, MatTable
} from '@angular/material/table';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmService } from '../../shared/services/confirm.service';
import { packageEditorLoadRequest } from '../../../store/package-editor/package-editor.actions';
import { PackageEditComponent } from '../package-edit/package-edit.component';

@Component({
    selector: 'app-packages-table',
    imports: [
    AsyncPipe,
    MatButton,
    MatCell,
    MatCellDef,
    MatCheckbox,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatPaginator,
    MatProgressSpinner,
    MatRow,
    MatRowDef,
    MatSort,
    MatTable,
    MatHeaderCellDef,
    MatSortHeader
],
    templateUrl: './packages-table.component.html',
    styleUrl: './packages-table.component.scss'
})
export class PackagesTableComponent implements OnInit {

    constructor(private store: Store<AppState>, public table: PackageTableService, private dialog: MatDialog,
                private confirmService: ConfirmService) {
    }

    dataSource = new PackagesData(this.table.currentPageEntries$);

    ngOnInit(): void {
        this.store.dispatch(packageTableRequest());
    }

    edit(id: string): void {
        this.store.dispatch(packageEditorLoadRequest({ id }));
        this.dialog.open(PackageEditComponent, { panelClass: 'modal-editor' });
    }
}
